/**
 * Returns the stack trace already attached to the given error, or the empty
 * string if the runtime did not provide one.
 *
 * Earlier versions of this helper called `Error.captureStackTrace(error)` to
 * "fill in" a stack when one was missing. That V8 API is a setter, not an
 * augmenter: per Node.js / V8 / MDN docs it creates a `.stack` property
 * describing the call site of `captureStackTrace` itself, overwriting
 * whatever stack was already on the error. When invoked from inside a
 * production logger it therefore destroys the original throw site for every
 * error it processes. See `getStackTrace.test.ts` for the regression pin.
 *
 * @param error - The error whose stack to read.
 * @returns The error's existing stack trace, or `''` if none.
 */
export function getStackTrace(error: Error): string {
  return error.stack ?? '';
}
